<script>
    import {Link, Router} from 'svelte-navigator';
</script>

<Router>
    <nav class="navbar navbar-expand-md navbar-dark  bg-primary">
  <div class="container">
    <a class="navbar-brand" href="/">rAheebwa</a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarColor01" aria-controls="navbarColor01" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarColor01">
      <!-- <ul class="navbar-nav ml-auto">
        <li class="nav-item">
          <Link class="nav-link active" to="/projects">Projects</Link>
        </li>
        <li class="nav-item">
          <Link class="nav-link" to="/about">About</Link>
        </li>
        <li class="nav-item">
          <Link class="nav-link" to="/contact">Contact</Link>
        </li>
      </ul> -->
    </div>
  </div>
</nav>
</Router>